<template>
  <main>
    <!-- <NavigationCard image="/assets/img/About/navigation.png" title="SANMAK LIGHTING" :showOverlay="false" /> -->
    <!-- <NavigationCard image="/assets/img/About/navigation.png" title="SANMAK LIGHTING"/> -->
     
    <NavigationCard image="/assets/img/VIP/navigation.png" topUrl="../../../assets/img/TopFirst/NewsTop.mp4"
    topUrlType="video" />
    <div class="page_content">
      <RouteNav></RouteNav>
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </main>
</template>

<script>
// import NavigationCard from '@/components/common/NavigationCard.vue';

import NavigationCard from '@/components/common/TopVideo.vue';
import RouteNav from '@/components/common/RouteNav.vue';
export default {
  name: 'News',
  components: {
    RouteNav,
    NavigationCard
  }
}
</script>
<style scoped>
@import '../../assets/css/main.css';
</style>